import PubSub from "underpub-js";
import Slick from "slick-carousel";
import Equalizer from "../../../../scripts/classes/Equalizer";

var ListingFiveUpBgImageCardsSlider = function(options) {

  this.options = {
    $el: false
  };

  $.extend(true, this.options, options);

};

ListingFiveUpBgImageCardsSlider.prototype.init = function() {

	var self = this;

	this.slideEq;

	// sliders
	this.$cardSlider = this.options.$el.find('.card-slider');

	// after the slider has initialized, call our svg inline script again
	// so that it can replace svg's in cloned slides
	this.$cardSlider.on('init', function(slick) {
		sitewide.inlineSvgs();

		// create the slide equalizer here, so that it detects clones that are created
		self.slideEq = new Equalizer( self.options.$el.find('.card') );
		self.slideEq.equalizeHeights();
		
		self.hideCardDetails();
	});

	// after SVG's are replaced, slide height will change so we run the equalizer again
	PubSub.subscribe('Sitewide:inlineSvgs:svgReplaced', function() {
	    self.slideEq.equalizeHeights();
	});

	// initialize card slider
	this.$cardSlider.slick({
		arrows: false,
		fade: false,
		speed: 750,
		slidesToShow: 5,
		swipeToSlide: true,
		infinite: true,
		centerMode: true,
		centerPadding: '11%',
		
		responsive: [
		
			{
				breakpoint: 2680,
				settings: {
					centerPadding: '6%'
				}
			},
			{
				breakpoint: 2400,
				settings: {
					centerPadding: '2%'
				}
			},
			{
				breakpoint: 2200,
				settings: {
					slidesToShow: 3,
					centerPadding: '16%'
				}
			},
			{
				breakpoint: 1960,
				settings: {
					slidesToShow: 3,
					centerPadding: '12%',
				}
			},
			{
				breakpoint: 1740,
				settings: {
					slidesToShow: 3,
					centerPadding: '6%',
				}
			},
			{
				breakpoint: 1500,
				settings: {
					slidesToShow: 3,
					centerPadding: '4%',
				}
			},
			{
				breakpoint: 1340,
				settings: {
					slidesToShow: 1,
					centerPadding: '32%',
				}
			},
			{
				breakpoint: 1100,
				settings: {
					slidesToShow: 1,
					centerPadding: '30%',
				}
			},
			{
				breakpoint: 960,
				settings: {
					slidesToShow: 1,
					centerPadding: '28%',
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
					centerPadding: '25%',
				}
			},
			{
				breakpoint: 620,
				settings: {
					slidesToShow: 1,
					centerPadding: '22%',
				}
			},
			{
				breakpoint: 540,
				settings: {
					slidesToShow: 1,
					centerPadding: '18%',
				}
			},
			{
				breakpoint: 460,
				settings: {
					slidesToShow: 1,
					centerPadding: '12%',
				}
			},
			{
				breakpoint: 400,
				settings: {
					slidesToShow: 1,
					centerPadding: '6%',
				}
			}
		]
		

	});

	// rerun equalizer and re-hide card details when window is resized
	PubSub.subscribe("resized", function() {
		// re-initializing the equalizer here fixes a bug where cloned slides weren't getting properly equalized
		self.slideEq = new Equalizer( self.options.$el.find('.card') );
		self.slideEq.equalizeHeights();

		self.hideCardDetails();
	});

};

ListingFiveUpBgImageCardsSlider.prototype.hideCardDetails = function() {

	var self = this;

	this.options.$el.find('.slick-slide').each(function() {

		var cardLowerContentHeight = $(this).find('.lower-content').outerHeight();

		$(this).find('.card-content').css('top', cardLowerContentHeight);

	});

};

export default ListingFiveUpBgImageCardsSlider;
